export const isJsonString = (str: any) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};
